import { InternalAxiosRequestConfig } from 'axios';
import { LOCAL_STORAGE } from '../../constants/app';
import { parseJwt } from '../../utils';

export const prepareRequestConfigHeaders = (config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem(LOCAL_STORAGE.TOKEN);
  const token_key = localStorage.getItem(LOCAL_STORAGE.TOKEN_KEY);
  const language = localStorage.getItem(LOCAL_STORAGE.LANG);
  const userIp = localStorage.getItem(LOCAL_STORAGE.USER_IP);
  const parsedToken = token ? parseJwt(token) : null;

  if (parsedToken && token_key) {
    config.headers.set('App-Name', parsedToken.app_name);
    config.headers.set('Token', token);
    config.headers.set('Token-Key', token_key);
  }

  if (language) {
    config.headers.set('language', language);
  }

  if (userIp) {
    config.headers.set('User-Ip', userIp);
  }
};
